import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Input from '../generic/Input'
import FormRenderer from '../generic/FormRenderer'
import Button from '../generic/Button'
import { inject } from 'mobx-react'
import { Redirect } from 'react-router-dom'

const ConfirmUserForm = inject('confirmUserStore')(observer(
  class ConfirmUserForm extends Component {
    constructor (props) {
      super(props)
      this.props.confirmUserStore.user.isDone = false
    }

    render () {
      const { confirmUserStore } = this.props
      if (confirmUserStore.user.isDone) {
        return <Redirect to='/' />
      }
      const { email, confirmationCode, isFetching } = confirmUserStore.user
      const confirmUserFields = [
        {
          component: Input,
          label: 'E-mail',
          type: 'text',
          name: 'email',
          id: 'confirm-user-email',
          placeholder: 'E-mail',
          value: email
        },
        {
          component: Input,
          label: 'Código de confirmação',
          type: 'text',
          name: 'confirmationCode',
          id: 'confirm-user-confirmationCode',
          placeholder: 'Código de confirmação',
          value: confirmationCode
        },
        {
          component: Button,
          text: 'Confirmar',
          type: 'submit',
          onClick: event => confirmUserStore.confirmUser(event),
          id: 'confirm-user-submit',
          isLoading: isFetching,
          styleClass: 'app-main-button'
        }
      ]
      return (
        <form>
          <FormRenderer fields={confirmUserFields} store={confirmUserStore} />
        </form>
      )
    }
  }
))

// const ConfirmUserForm = inject('confirmUserStore')(observer((props) => {
//   const { confirmUserStore } = props
//   const { email, confirmationCode, isFetching } = confirmUserStore.user
//   const confirmUserFields = [
//     {
//       component: Input,
//       label: 'E-mail',
//       type: 'text',
//       name: 'email',
//       id: 'confirm-user-email',
//       placeholder: 'E-mail',
//       value: email
//     },
//     {
//       component: Input,
//       label: 'Código de confirmação',
//       type: 'text',
//       name: 'confirmationCode',
//       id: 'confirm-user-confirmationCode',
//       placeholder: 'Código de confirmação',
//       value: confirmationCode
//     },
//     {
//       component: Button,
//       text: 'Confirmar',
//       type: 'submit',
//       onClick: event => confirmUserStore.confirmUser(event),
//       id: 'confirm-user-submit',
//       isLoading: isFetching,
//       styleClass: 'app-main-button'
//     }
//   ]
//   return (
//     <form>
//       <FormRenderer fields={confirmUserFields} store={confirmUserStore} />
//     </form>
//   )
// }))

export default ConfirmUserForm



// WEBPACK FOOTER //
// ./src/components/confirm-user/ConfirmUserForm.js